import * as React from 'react';
import { Operation, GetOperationName } from '@config/index';
import {
  Reference,
  ReferenceNode,
  TriggerCondition,
  ConditionContent
} from '@interface/index';
import { referenceUtils } from '@component/index';
import { ParameterMapStore } from '@lib/index';

export const TriggerConditionsRender = (props: { data: TriggerCondition[]; }) => {

  const [result, setResult] = React.useState('');
  React.useEffect(() => {
    Promise.all(props.data.map((tc: TriggerCondition) => {
      return renderTriggerCondition(tc);
    })).then((results: string[]) => {
      setResult(results.join('\n'));
    });
  });
  return <pre style={{ marginBottom: 0 }} key={result}>{result}</pre>;
};

async function renderTriggerCondition(data: TriggerCondition) {
  return Promise.all(data.conditions.map((content: ConditionContent) => {
    return renderCondition(data, content);
  })).then((results: string[]) => {
    return results.join('\n');
  });
}

async function renderCondition(tc: TriggerCondition, c: ConditionContent) {
  const variable = renderConditionVariable(tc.variable, c);
  const op = renderConditionOperation(c.operation);
  const ret = `${variable} ${op}`;

  if (c.operation === Operation.RequireCondition ||
    c.operation === Operation.NotEmptySetCondition) {
    return ret;
  }

  const val = await renderConditionValue(c.value);
  return `${ret} ${val}`;
}

function renderConditionOperation(operation: Operation) {

  switch (operation) {
    case Operation.EqualToCondition:
      return '=';
    case Operation.GreaterThanCondition:
      return '>';
    case Operation.LessThanCondition:
      return '<';
    case Operation.GreaterThanOrEqualCondition:
      return '>=';
    case Operation.LessThanOrEqualCondition:
      return '<=';
    case Operation.NotEqualToCondition:
      return '!=';
    default:
      return GetOperationName(operation);
  }
}

function renderConditionVariable(variable: Reference, condition: ConditionContent) {

  let variableName = (variable || []).map((node: ReferenceNode) => {
    let name = node.name;
    if (node.showIndex) {
      name = `${name}[${node.index || 0}]`;
    }
    return name;
  }).join('.');

  const isTableSize = condition.operationAt === 'table_row';

  if (isTableSize) {
    variableName = variableName + '.size';
  }

  return variableName;
}

async function renderConditionValue(v: string[]) {

  if (v.length === 1) {

    const directParam = ParameterMapStore.get(v[0]);

    if (directParam) {
      return directParam.name;
    }

    const ret = await referenceUtils.toReference(v[0], ParameterMapStore.all());
    return ret.text;
  }

  const rets: string[] = [];

  for (const vi of v) {
    const ret = await referenceUtils.toReference(vi, ParameterMapStore.all());
    rets.push(ret.text);
  }

  return `[${rets.join(',')}]`;
}
